<script setup lang="ts">
import { useFairStore } from '@/stores/fair'
import type { SelectChangeEvent } from 'primevue'
import { computed } from 'vue'

const fairStore = useFairStore()

const currentFairId = computed(() => fairStore.fair?.id)

function changeFair(event: SelectChangeEvent) {
  fairStore.changeCurrentFair(event.value as number)
}
</script>

<template>
  <div>
    <Select
      v-model="currentFairId"
      :options="fairStore.fairs.filter((f) => f.isDisplay && f.status !== '완료')"
      :option-label="$i18n.locale == 'ko' ? 'name' : 'nameEng'"
      option-value="id"
      class="w-full text-primary-500 font-bold !border-primary"
      :filter="true"
      :placeholder="$t('placeholder.selectFair')"
      scroll-height="20rem"
      @change="changeFair" />
  </div>
</template>
